export default {
  app: {
    featured: 'Destacadas',
    random: 'Aleatorio',
    explore: 'Explora',
    keywords: 'Palabras Claves',
    search: 'Búsqueda',
  },
  explore: {
    filters: 'Filtros',
    resetFilters: 'Reiniciar Filtros',
    addKeyword: 'Agregar Palabra Clave',
  },
  recipe: {
    contributedBy: 'Aportado por',
    ingredients: 'Ingredientes',
    directions: 'Instrucciones',
    fullRecipe: 'Mira la receta completa en',
    similarDrinks: 'Bebidas similares',
  },
  featuredRecipes: {
    loadMore: 'Cargar Más',
  },
  recipeFind: {
    filterBy: 'Filtrar por',
    name: 'Nombre',
    ingredients: 'Ingredientes',
    keywords: 'Palabras Clave',
    searchForIngredients: 'Puedes buscar múltiples ingredientes separandolos con espacios',
    searchForKeywords: 'Puedes buscar múltiples palabras claves separandolas con espacios',
  },
  recipeList: {
    viewRecipe: 'Ver Receta',
  },
  recipeToolbar: {
    print: 'Imprimir',
    share: 'Compartir',
    shareOnFacebook: 'Compartir en Facebook',
    shareOnTwitter: 'Compartir en Twitter',
    copyURL: 'Copiar URL',
    hideImage: 'Ocultar imagen',
  },
  favorites: {
    removeAllFavorites: 'Eliminar Todos Los Favoritos',
    noFavoriteDrinks: 'No tienes bebidas favoritas',
    removeFavoritesPrompt: 'Estás seguro que quieres eliminar todos los favoritos？',
    delete: 'Eliminar',
    cancel: 'Cancelar',
  },
  keywordList: {
    enterYourKeyword: 'Introduce tu palabra clave',
  },
  search: {
    findYourDrink: 'Encuentra Tu Bebida',
  },
  pageNotFound: {
    pageNotFound: 'No se encontró la página que estás buscando',
    backToHome: 'Volver al Inicio',
  },
};
